export default "__VITE_ASSET__QUjhjDwX__"